// extracted by mini-css-extract-plugin
export default {"other-workflow-skeleton":"lGZowA","accordion-with-tooltip":"wF1tNo","icon":"LjOLGn"};